import { useIsScreenSizeBiggerThanTailwindSize } from "hooks/useIsScreenSizeBiggerThanTailwindSize";
import { CoverProps } from "hardcover-ui/theme/components/cover";
import CoverLink, { CoverLinkProps } from "./CoverLink";

interface ResponsiveCoverLinkProps extends CoverLinkProps {
  sizeSm: CoverProps["size"];
  sizeLg: CoverProps["size"];
}

export default function ResponsiveCoverLink({
  book,
  edition,
  size,
  variant,
  settings,
  className = "",
  sizeLg,
  sizeSm,
}: ResponsiveCoverLinkProps) {
  const isLarge = useIsScreenSizeBiggerThanTailwindSize("lg");

  return (
    <CoverLink
      book={book}
      edition={edition}
      size={isLarge === null ? size : isLarge ? sizeLg : sizeSm}
      variant={variant}
      settings={settings}
      className={className}
    />
  );
}
